import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { AdminBackgroundTaskStatus } from '../../enums/admin-background-task-status';
import { AdminBackgroundTaskContextOperationsResponse } from './admin-background-task-context-operations.response';
import { AdminBackgroundTaskType } from '../../enums/admin-background-task-type';

@jsonObject
export class AdminBackgroundTaskCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly status!: AdminBackgroundTaskStatus;

  @jsonMember(String)
  public readonly type!: AdminBackgroundTaskType;

  @jsonMember(Number)
  public readonly progress!: number;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly updatedAt!: Date;

  @jsonMember(AdminBackgroundTaskContextOperationsResponse)
  public readonly contextOperations!: AdminBackgroundTaskContextOperationsResponse;
}
